@if (miscModel) {
  <customizer-component-header [overrideTranslateName]="'CUSTOMIZER.COMPONENTS.GROOVE.PEN'" [showTranslateDecription]="false" [menu]="menu">
    <div class="has-padding-horizontal-30px">
      <img [src]="this.imageService.GetGrooveColorPenImage()" />
      <div>
        {{'CUSTOMIZER.COMPONENTS.GROOVE.ADDPEN1'| translate}} {{miscModel.LastSplitEcommerceNoUnique}} {{'CUSTOMIZER.COMPONENTS.GROOVE.ADDPEN2'| translate}}
      </div>
      <add-to-bag-button [disabled]="false" (addToBagChange)="addTobag()"></add-to-bag-button>
      <button (click)="dontAdd()" class="btn btn-block btn-secondary">{{'CUSTOMIZER.COMPONENTS.CONFIGURATION.DONTADD' | translate}}</button>
    </div>
  </customizer-component-header>
}